import { jsx as _jsx } from "react/jsx-runtime";
import { useEstimationResult } from '@estimation/entities/estimationSolution';
import { Box } from '@mui/material';
import styles from './styles.module.scss';
export function PlotGraph() {
    const { estimationData } = useEstimationResult();
    return (_jsx(Box, { width: '100%', children: _jsx("iframe", { src: estimationData.plot_url, title: "Embedded Content", className: styles.graph }) }));
}
